import { parseElementFromString } from 'anodum';
import isValidUrl from '../../utils/helpers/is-valid-url';
import templateConstants from '../../template/constants';
import { HOST_SOCIAL_ICONS_MAP } from '../constants/host-social-icons-map';

const injectSiteSocialLinksSettings = (options) => {
  const { settingValue, targetElement, variable, socialIcons } = options;
  const targetBlock = targetElement.cloneNode(false);

  settingValue.forEach((value) => {
    if (!isValidUrl(value)) return;

    const { hostname } = new URL(value);
    const socialName = Object.keys(HOST_SOCIAL_ICONS_MAP).find((name) => hostname.includes(name));
    const iconName = HOST_SOCIAL_ICONS_MAP[socialName];
    const element = parseElementFromString(variable.templates.item, true);
    const linkElement = element.querySelector(variable.selectors.item);
    const iconElement = element.querySelector(variable.selectors.icon);
    linkElement.setAttribute('href', value);

    if (!socialIcons[iconName] && !socialIcons[templateConstants.SOCIAL_ICON_DEFAULT]) {
      linkElement.innerText = hostname;

      targetBlock.appendChild(element);
      return;
    }
    iconElement.setAttribute(
      'src',
      socialIcons[iconName] || socialIcons[templateConstants.SOCIAL_ICON_DEFAULT]
    );

    targetBlock.appendChild(element);
  });

  if (targetBlock.hasChildNodes()) {
    targetElement.innerHTML = targetBlock.innerHTML;
  }

  return targetElement;
};

export default injectSiteSocialLinksSettings;
